import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  label: {
    fontSize: "1.25rem",
    position: "relative",
    paddingRight: "25px",
    "&div": {
      marginTop: 0,
      "&:before": {
        bottom: "5px",
      },
      "&:after": {
        bottom: "5px",
      },
      svg: {
        top: "0",
      },
    },
  },
  disabled: {
    "&:hover": {
      cursor: "not-allowed",
    },
  },
});

const DmvQuerySelect = ({ nightMode, value, setValue, options }) => {
  const classes = useStyles();
  return (
    <FormControl margin="dense" variant="standard" className={""}>
      <InputLabel
        htmlFor="dmv-query-select"
        margin="dense"
        shrink={true}
        className={classes.label}
        style={{
          color: nightMode ? "white" : "black",
          fontWeight: "bold",
        }}
        id={"dmv-query-label"}
      >
        Query Type
      </InputLabel>
      <Select
        id="dmv-query-select"
        native={false}
        value={options.find(option => option?.id === value?.id) || ""}
        onChange={e => {
          e.stopPropagation();
          setValue(e.target.value);
        }}
        renderValue={value => value?.name}
        style={{ marginTop: "0px" }}
      >
        {options &&
          options.map(option => {
            return (
              <Tooltip
                title={option?.tooltip || ""}
                aria-label="add"
                key={option?.id}
                value={option}
              >
                <MenuItem value={option}>{option?.name}</MenuItem>
              </Tooltip>
            );
          })}
      </Select>
    </FormControl>
  );
};

export default DmvQuerySelect;
